import { Badge } from "@nexus/ui";
import type { ComponentProps } from "react";
import { useTranslation } from "react-i18next";

import type { PersonaOpportunityStatus } from "../../../api/persona-opportunity-sets.api.js";
import { personaOpportunityStatusLabel } from "../../../lib/persona-opportunity-tab-status.js";

type BadgeVariant = NonNullable<ComponentProps<typeof Badge>["variant"]>;

const STATUS_VARIANT: Record<PersonaOpportunityStatus, BadgeVariant> = {
  NEW: "status-sent",
  SCRIPTS_GENERATED: "status-delivered",
  BRIEFS_GENERATED: "status-in-production",
  SCRIPTS_AND_BRIEFS_GENERATED: "status-delivered",
  SENT_TO_VENDOR: "slate",
};

export function OpportunityHubStatusBadge({ status }: { status: PersonaOpportunityStatus }) {
  const { t } = useTranslation();
  return (
    <Badge variant={STATUS_VARIANT[status] ?? "default"} className="text-[11px] font-medium">
      {personaOpportunityStatusLabel(t, status)}
    </Badge>
  );
}
